import { ServerErrorSticker } from '@/assets/images';
import { Button } from '@/components/common';
import { showAlertSuccess } from '@/utils';

const InternalServerError = ({
  errorMessage = 'Internal Server Error',
}: {
  errorMessage?: string;
}) => {
  const copyMessage = () => {
    navigator.clipboard.writeText(errorMessage);
    showAlertSuccess('Message copied to clipboard!');
  };

  const reload = () => {
    if (window.history.length > 2) {
      window.history.back();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center bg-transparent overflow-y-auto">
      <ServerErrorSticker className="flex-shrink-0" />
      <h1 className="text-[32px] font-bold text-brand-primary-darkest mt-10 mb-3 text-center">
        Uh...Oh...! Something Went Wrong
      </h1>
      <span className="font-medium text-base text-neutral-n7 text-center">
        Please reload the page or copy the error message and send an email to <br /> our
        Administrator via <u>admin.smartoffice@stengg.com</u>
      </span>
      <div className="text-base font-medium text-neutral-n7 border border-solid border-neutral-n5 bg-neutral-n3 text-center my-6 mx-8 p-5 rounded-soft h-auto">
        {errorMessage}
      </div>
      <div className="flex items-center flex-wrap justify-center gap-3">
        <Button variant="primary" size="lg" className="w-[208px]" onClick={reload}>
          Reload Page
        </Button>
        <Button variant="secondary" size="lg" className="w-[208px]" onClick={copyMessage}>
          Copy Message
        </Button>
      </div>
    </div>
  );
};

export default InternalServerError;
